import React from 'react';

// Internal Import
import './index.css';
import { createTheme } from './theme';
import { store } from './modules/redux/store';

// External Import
import { Provider } from 'react-redux';
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import { RouterScreen } from './modules/router';

const theme = createTheme();
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Provider store={store}>
          <RouterScreen />
        </Provider>
      </BrowserRouter>
    </ThemeProvider>
)
